import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'v3/components/Snackbar';
import Text from 'v3/components/Text';
import api from 'services/api';
import { usePermission } from 'hooks';
import Details from '../Details';
import Register from '../Register';
import { CompanyProvider } from './context';

function getInitialCompanyState() {
  return {
    name: null,
    status: true,
    can_issue: false,
    client_type: 1,
    product_type: 2,
    issuers: [],
    integrations: [],
    clients: [],
    riskManagers: [],
    pricingOrder: [],
    checkList: [],
    required_checklist: false,
    priorityFleetDuration: null,
    priorityFleetVehicles: {
      data: [],
      total: 0,
      page: 1,
      lastPage: 1,
      perPage: 5,
    },
    triggers: [],
    goals: [],
  };
}

function CompanySharedContent({ companyId }) {
  const snackbar = useSnackbar();
  const dispatch = useDispatch();

  const [company, setCompany] = useState(getInitialCompanyState);
  const [isFetching, setFetching] = useState(false);
  const [errors, setErrors] = useState({});
  const [prevCompany, setPrevCompany] = useState({});
  const hasPermissionToEdit = usePermission('ALTERAR_EMPRESAS');

  function showSnackbar(text, options) {
    snackbar.show(<Text> {text} </Text>, options);
  }

  useEffect(() => {
    let active = true;

    async function fetchCompany() {
      try {
        setFetching(true);

        const response = await api.get(`v3/company/${companyId}`);
        if (!active) return;

        setCompany((previous) => ({ ...previous, ...response.data }));
        setPrevCompany(response.data);
      } catch (ex) {
        if (!active) return;

        snackbar.show(<Text>Não foi possível carregar essa empresa</Text>, {
          type: 'error',
        });
      } finally {
        if (active) {
          setFetching(false);
        }
      }
    }

    if (companyId) {
      fetchCompany();
      return () => {
        active = false;
      };
    }

    return () => {
      active = false;
    };
  }, [companyId]);

  function setData(data) {
    setCompany((prev) => ({ ...prev, ...data }));
  }
  function cancelEditing(setEditing) {
    setCompany(prevCompany);
    if (setEditing) setEditing(false);
  }

  useEffect(() => {
    if (companyId) {
      dispatch({
        type: 'VIEW_INSTANCE',
        instance: company.name,
      });
    }
  }, [companyId, company.name, dispatch]);

  return (
    <CompanyProvider
      value={{
        data: company,
        setData,
        isFetching,
        errors,
        setErrors,
        showSnackbar,
        cancelEditing,
        setPrevCompany,
        hasPermissionToEdit,
      }}
    >
      {companyId ? <Details /> : <Register />}
    </CompanyProvider>
  );
}

export default function CompanyShared() {
  const params = useParams();
  const routeKey = params.id || 'create';

  return <CompanySharedContent key={routeKey} companyId={params.id} />;
}
